import { Component, OnInit, AfterViewChecked, Inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { Order } from '../order';
import { ShoppingcartService } from '../shoppingcart.service';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { DeliveryData } from './delivery';
import { PacketaObject } from './packeta';
import { Material } from '../material';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { FoxpostpopupComponent } from '../foxpostpopup/foxpostpopup.component';
import { LoadingService } from '../loading-spinner/loading.service';
import { GoogleTagManagerService } from '../../google-tag-manager/google-tag-manager.service';
import { PersonalData } from '../contact/personal-data';
import { DeliveryOption } from './deliveryoptions';
import { GetDeliveryOptionsResponse } from './getdeliveryoptionsresponse';
import { ApiRequestService } from '../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { ProductList } from '../cartsummary/productList';
import { DatePipe } from '@angular/common';
import { DateutilpipePipe } from '../../dateutilpipe/dateutilpipe.pipe';

declare let Packeta: any;
@Component({
    selector: 'pw-typeofdelivery',
    templateUrl: './typeofdelivery.component.html',
    styleUrls: ['./typeofdelivery.component.scss']
})
export class TypeofdeliveryComponent implements OnInit, AfterViewChecked {
    deliveryOptionList: DeliveryOption[] = [];

    getDeliveryOptionsUrl = '/order/get-delivery-options';

    order?: Order = {};

    data: DeliveryData = {};

    totalAmount = 0;

    errorMessage = '';

    packetaUrl = 'https://widget.packeta.com/v6/';

    isPacketa = false;

    packetaApiKey = '5480caf3c09423e2';

    packetaOptions = {
        valueFormat: '"Packeta",id,carrierId,carrierPickupPointId,name,city,street'
    };

    Packeta: any;

    packetaObject: PacketaObject = {};

    private _packetaAddress = '';

    enterAnimationDuration = '500ms';

    exitAnimationDuration = '200ms';

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };

    isPreorder = false;

    materials: Material[] = [];

    totalPrice: number = 0;

    separated = false;

    personalData?: PersonalData = {};

    isExtraSmall: Observable<BreakpointState>;

    orderBaseUrl = '';

    deliveryOptionElement: DeliveryOption = {};

    constructor(
        private _loadingService: LoadingService,
        private readonly breakpointObserver: BreakpointObserver,
        private _matDialog: MatDialog,
        private _fb: FormBuilder,
        private _shoppingCartService: ShoppingcartService,
        private _router: Router,
        private _googleTagManagerService: GoogleTagManagerService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private _datePipe: DatePipe,
        private dateUtilPipe: DateutilpipePipe

    ) {
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);

        this.orderBaseUrl = _orderBackendUrl;
    }
    ngAfterViewChecked(): void {
        this.ngZone.runOutsideAngular(() => {
            this.ref.detectChanges();
            setTimeout(() => {
                this.data = JSON.parse(sessionStorage.getItem('deliveryData') as string) as DeliveryData;
            }, 0);
        });
    }

    ngOnInit(): void {
        this.getDeliveryOptions();
    }

    getDeliveryOptions() {
        this._apiRequestService
            .sendRequest<{}, GetDeliveryOptionsResponse>(this.orderBaseUrl, true, {}, true, this.getDeliveryOptionsUrl)
            .subscribe((response: GetDeliveryOptionsResponse) => {
                this.deliveryOptionList = response.deliveryOptionsList as DeliveryOption[];
                this.personalData = JSON.parse(sessionStorage.getItem('personalData') as string) as PersonalData;
                this.materials = JSON.parse(sessionStorage.getItem('materials') as string) as Material[];
                this.separated = JSON.parse(sessionStorage.getItem('separated') as string) as boolean;

                if (this.materials.length === 0) {
                    this._router.navigateByUrl('/');
                }

                this.deliveryOptionList.forEach((deliveryOption) => {
                    if (!sessionStorage.getItem('deliveryData')) {
                        if (deliveryOption.name === 'STORE_PICKUP') {
                            this.deliveryOptionElement = deliveryOption;
                            this.createDefaultDeliveryData();
                        }
                    } else {
                        this.createDeliveryData();
                        if (deliveryOption.name === this.data.deliveryOption) {
                            this.deliveryOptionElement = deliveryOption;
                        }
                    }
                });
            });
    }

    createDefaultDeliveryData() {
        this.data = {
            deliveryOption: this.deliveryOptionElement.name,
            deliveryZipCode: this.personalData?.zipCode,
            deliverySettlement: this.personalData?.settlement,
            deliveryAddress: this.personalData?.address,
            deliveryFee: this.deliveryOptionElement.deliveryFee,
            handlingFee: this.deliveryOptionElement.handlingFee
        };
        sessionStorage.setItem('deliveryData', JSON.stringify(this.data));
    }

    createDeliveryData() {
        const deliveryData: DeliveryData = JSON.parse(sessionStorage.getItem('deliveryData') as string) as DeliveryData;
        this.data = {
            deliveryOption: deliveryData.deliveryOption,
            deliveryZipCode: deliveryData.deliveryZipCode,
            deliverySettlement: deliveryData.deliverySettlement,
            deliveryAddress: deliveryData.deliveryAddress,
            deliveryFee: deliveryData.deliveryFee,
            handlingFee: deliveryData.handlingFee
        };
    }

    //TODO ellenőrizni!!!
    goToPay() {
        this.data = JSON.parse(sessionStorage.getItem('deliveryData') as string) as DeliveryData;
        this.generateProductItemList();
        if (this.data.deliverySettlement === undefined) {
            this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'Kérem válassza ki a szállítási címet!', MAT_ICON.error);
            this.dismissError();
        } else {
            this._googleTagManagerService.addShippingInfo(this.materials, this.deliveryOptionElement.name!);
            this._router.navigateByUrl('/payment');
        }
    }

    setDeliveryDataInToSession(deliveryOption: DeliveryOption) {
        if (deliveryOption.name === 'STORE_PICKUP' || deliveryOption.name === 'MPL') {
            this.data = {
                deliveryOption: deliveryOption.name,
                deliveryZipCode: this.personalData?.zipCode,
                deliverySettlement: this.personalData?.settlement,
                deliveryAddress: this.personalData?.address,
                deliveryFee: deliveryOption.deliveryFee,
                handlingFee: deliveryOption.handlingFee
            };
            sessionStorage.setItem('deliveryData', JSON.stringify(this.data));

        }
        else {
            this.data = {
                deliveryOption: deliveryOption.name,
                deliveryZipCode: 0,
                deliverySettlement: undefined,
                deliveryAddress: undefined,
                deliveryFee: deliveryOption.deliveryFee,
                handlingFee: deliveryOption.handlingFee
            };
            sessionStorage.setItem('deliveryData', JSON.stringify(this.data));
        }
    }

    showSelectedPickupPoint(point: any): PacketaObject {
        sessionStorage.setItem('packeta', JSON.stringify(point));

        return point;
    }

    get packetaAddress() {
        return this._packetaAddress;
    }
    set packetaAddress(value: string) {
        this._packetaAddress = value;
    }

    loadSelectedMaterial(enterAnimationDuration: string, exitAnimationDuration: string) {
        const popupDialog = this._matDialog.open(FoxpostpopupComponent, {
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            data: this.deliveryOptionElement
        });
        const smallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '70vh');
            } else {
                popupDialog.updateSize('calc(50% - 50px)', '');
            }
        });
        popupDialog.afterClosed().subscribe(() => {
            smallDialogSubscription.unsubscribe();
        });
    }

    setDeliveryDataIntoSession() {
        if (this.deliveryOptionElement.name === 'STORE_PICKUP') {
            this.data = {
                deliveryOption: this.deliveryOptionElement.name,
                deliveryZipCode: this.personalData?.zipCode,
                deliverySettlement: this.personalData?.settlement,
                deliveryAddress: this.personalData?.address,
                deliveryFee: this.deliveryOptionElement.deliveryFee,
                handlingFee: this.deliveryOptionElement.handlingFee
            };
            sessionStorage.setItem('deliveryData', JSON.stringify(this.data));
            if (this._shoppingCartService.order && this.order) {
                this.order.deliveryData = this.data;
                this._shoppingCartService.order.deliveryData = this.data;
                this._shoppingCartService.order.totalPrice = this._shoppingCartService.order.totalPriceOfBooks;
            }
        }

        if (sessionStorage.getItem('deliveryData')) {
            this.data = JSON.parse(sessionStorage.getItem('deliveryData') as string) as DeliveryData;
            if (this._shoppingCartService.order && this.order) {
                this.order.deliveryData = this.data;
                this._shoppingCartService.order.deliveryData = this.data;
                this._shoppingCartService.order.totalPrice = this._shoppingCartService.order.totalPriceOfBooks;
            }
        } else {
            this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'Kérem válassza ki a szállítási címet!', MAT_ICON.error);
            this.dismissError();
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

    hasPreorder(materials: Material[]) {
        materials.forEach((material) => {
            if (material.hasPreorder) {
                this.isPreorder = true;
            }
        });
        if (this.isPreorder) {
            this.deliveryOptionList.forEach((deliveryoption, index) => {
                if (deliveryoption.name === 'STORE_PICKUP') {
                    this.deliveryOptionList.splice(index, 1);
                }
            });
        }
    }

    generatePreorderedProductList(): Material[] {
        let preorderMaterialList: Material[] = [];
        if (this.hasMaterialPreorder()) {
            this.materials.forEach((material) => {
                if (material.hasPreorder) {
                    preorderMaterialList.push(material);
                }
            });
        }
        return preorderMaterialList;
    }

    hasMaterialPreorder(): boolean {
        let hasPreorder = false;
        this.materials.forEach((material) => {
            if (material.hasPreorder) {
                hasPreorder = true;
            }
        });
        return hasPreorder;
    }

    generateProductItemList() {
        let preOrderMaterialsList: Material[] = this.generatePreorderedProductList();
        let productList: ProductList[] = [];
        let productItems: Material[] = [];
        let numberOfNormalDelivery = 0;
        let numberOfPreorderDelivery = 0;
        let preOrderProductMap: Map<Date | undefined, Material[]> = new Map(preOrderMaterialsList.map((obj) => [obj.available, productItems]));

        preOrderProductMap.forEach((value: Material[], key: Date | undefined) => {
            productItems = [];
            let sum = 0;
            preOrderMaterialsList.forEach((preorder) => {
                if (key === preorder.available) {
                    sum += preorder.originalPrice! * preorder.quantity!;
                    productItems.push(preorder);
                }
            });
            preOrderProductMap.set(key, productItems);

            if (!this.isDiscountLimitedUntil(preOrderMaterialsList)) {
                if (sum < this.deliveryOptionElement.freeDeliveryLimit! || !this.deliveryOptionElement.freeDeliveryAllowed) {
                    numberOfPreorderDelivery = numberOfPreorderDelivery + 1;
                }
            }
            else if (this.isDiscountLimitedUntil(preOrderMaterialsList)) {
                numberOfPreorderDelivery = numberOfPreorderDelivery + 1;
            }

            if (productItems.length > 0) {
                let preorder: ProductList = {
                    expectedDeliveryDate: this.formatDate(key),
                    materialList: productItems,
                    sum: sum
                };
                productList.push(preorder);
            }
        });

        let totalPriceOfNotPreorderedProducts = 0;
        let notPreOrderedMaterial: Material[] = [];
        this.materials.forEach((materialElement) => {
            if (!materialElement.hasPreorder) {
                notPreOrderedMaterial.push(materialElement);
                totalPriceOfNotPreorderedProducts += materialElement.originalPrice! * materialElement.quantity!;
            }
        });

        if (!this.isDiscountLimitedUntil(notPreOrderedMaterial)) {
            if ((totalPriceOfNotPreorderedProducts < this.deliveryOptionElement.freeDeliveryLimit! && totalPriceOfNotPreorderedProducts !== 0) || !this.deliveryOptionElement.freeDeliveryAllowed) {
                numberOfNormalDelivery = 1;
            }
        }

        else if (this.isDiscountLimitedUntil(notPreOrderedMaterial)) {
            if (totalPriceOfNotPreorderedProducts !== 0) {
                numberOfNormalDelivery = 1;
            }
        }

        if (notPreOrderedMaterial.length > 0) {
            let product: ProductList = {
                expectedDeliveryDate: 'Raktáron',
                materialList: notPreOrderedMaterial,
                sum: totalPriceOfNotPreorderedProducts
            };
            productList.push(product);
        }
        this.addDeliveryFeeToProductsItem(productList);
        sessionStorage.setItem('productList', JSON.stringify(productList));
        //TODO 'numberOfDelivery' is unnecessary, because I can make a sum from productlist deliveryFee-s and that's the whole deliveryFeeSum!!!
        sessionStorage.setItem('numberOfDelivery', JSON.stringify(numberOfNormalDelivery + numberOfPreorderDelivery));

        sessionStorage.setItem('deliveryFeeSum', JSON.stringify(this.generateDeliveryFeeSum(productList)));
    }

    formatDate(key: any): string {
        const formatted = this.dateUtilPipe.transform(key);
        return 'Várható megjelenés: ' + formatted;
    }

    isDiscountLimitedUntil(materials: Material[]): boolean {
        return materials.some(material => material.discountLimitedUntil !== null);

    }

    addDeliveryFeeToProductsItem(productList: ProductList[]) {
        productList.forEach(productItem => {
            if (this.isDiscountLimitedUntil(productItem.materialList!)) {
                productItem.deliveryFee = this.data.deliveryFee

            }
            else if (!this.isDiscountLimitedUntil(productItem.materialList!)) {
                if (productItem.sum! > this.deliveryOptionElement.freeDeliveryLimit! && this.deliveryOptionElement.freeDeliveryAllowed) {
                    productItem.deliveryFee = 0;
                }
                else {
                    productItem.deliveryFee = this.data.deliveryFee;
                }

            }
        });

    }

    //handlingFee is calculated in cartsummary.component.ts with totalPrice and deliveryFeeSum together
    generateDeliveryFeeSum(productList: ProductList[]): number {
        let deliveryFeeSum: number = 0;

        productList.forEach(product => {
            if (this.separated) {
                deliveryFeeSum += product.deliveryFee!;
            }
            else {
                deliveryFeeSum = product.deliveryFee!;
            }
        });

        return deliveryFeeSum;
    }
}
